import { RequestIdentity } from '../models/RequestIdentity';
import { v4 as uuidv4 } from 'uuid';

/** Строковое представление RequestIdentity **/
export const requestIdentityToString = (requestIdentity: RequestIdentity): string => {
  try {
    return `${requestIdentity.configName}/${requestIdentity.id}/${requestIdentity.type}`;
  } catch (e) {
    return uuidv4();
  }
};
